import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts, { Options } from 'highcharts/highstock';
import ComponentErrorBoundary, { ComponentErrorBoundaryState } from 'common-react/src/error/ComponentErrorBoundary';

type StockChartWithBoundaryProps = {
  options: Options | null;
  fallbackErrorComponent: (errorState: ComponentErrorBoundaryState, clearState: () => void) => React.ReactElement;
};

export const StockChartWithBoundary: React.FC<StockChartWithBoundaryProps> = ({
  options,
  fallbackErrorComponent,
}) => {
  if (!options) {
    return null;
  }

  return (
    <ComponentErrorBoundary fallbackErrorComponent={fallbackErrorComponent}>
      <HighchartsReact
          immutable={true}
          highcharts={Highcharts}
          constructorType={'stockChart'}
          options={options}
      />
    </ComponentErrorBoundary>
  );
};
